import styled from 'styled-components'

export const Wrapper = styled.div`
	/* Avoid collapsing margins */
	padding: 0.1px;
	display: block;
`
